var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5419_2465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5419_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 18C1.15 16.2166 1.69583 14.575 2.6375 13.075C3.57917 11.575 4.83333 10.3833 6.4 9.49995L4.55 6.29995C4.45 6.14995 4.425 5.99162 4.475 5.82495C4.525 5.65828 4.63333 5.53328 4.8 5.44995C4.93333 5.36662 5.08333 5.34995 5.25 5.39995C5.41667 5.44995 5.55 5.54995 5.65 5.69995L7.5 8.89995C8.93333 8.29995 10.4333 7.99995 12 7.99995C13.5667 7.99995 15.0667 8.29995 16.5 8.89995L18.35 5.69995C18.45 5.54995 18.5833 5.44995 18.75 5.39995C18.9167 5.34995 19.0667 5.36662 19.2 5.44995C19.3667 5.53328 19.475 5.65828 19.525 5.82495C19.575 5.99162 19.55 6.14995 19.45 6.29995L17.6 9.49995C19.1667 10.3833 20.4208 11.575 21.3625 13.075C22.3042 14.575 22.85 16.2166 23 18H1ZM7 15.25C7.35 15.25 7.64583 15.1291 7.8875 14.8875C8.12917 14.6458 8.25 14.35 8.25 14C8.25 13.65 8.12917 13.3541 7.8875 13.1125C7.64583 12.8708 7.35 12.75 7 12.75C6.65 12.75 6.35417 12.8708 6.1125 13.1125C5.87083 13.3541 5.75 13.65 5.75 14C5.75 14.35 5.87083 14.6458 6.1125 14.8875C6.35417 15.1291 6.65 15.25 7 15.25ZM17 15.25C17.35 15.25 17.6458 15.1291 17.8875 14.8875C18.1292 14.6458 18.25 14.35 18.25 14C18.25 13.65 18.1292 13.3541 17.8875 13.1125C17.6458 12.8708 17.35 12.75 17 12.75C16.65 12.75 16.3542 12.8708 16.1125 13.1125C15.8708 13.3541 15.75 13.65 15.75 14C15.75 14.35 15.8708 14.6458 16.1125 14.8875C16.3542 15.1291 16.65 15.25 17 15.25Z",
    fill: "#D4D8E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformAndroid);
export default __webpack_public_path__ + "static/media/platform-android.909201bac10f813a75a43d2f4ae8869b.svg";
export { ForwardRef as ReactComponent };